import { render } from "./EnterCarrier.vue?vue&type=template&id=06d8b3de&ts=true"
import script from "./EnterCarrier.vue?vue&type=script&lang=ts"
export * from "./EnterCarrier.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__